export const COMPASS_TIN = '20-2226269'; 
export const ROLE_BASED_DASHBOARDS = ['Super Admin', 'Adjuster']; 